import { connect } from 'react-redux';
import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import "../../Style/View/loginView.css";
import * as repositoryActions from '../../Store/Actions/repositoryActions';


class LoginView extends Component {
  constructor(props) {
    super(props);
    // State is in reducers
    this.state = {
      login:"",
      password:"",
      domain:"",
      message:"",
    };

  }
  // METHOD ///////////////////////////////////////////////////////
  toggleConnect = () =>{
    if(this.state.login === ""){
      this.setState({message:"all field required : login is empty"});
    }else if(this.state.password === ""){
      this.setState({message:"all field required : password is empty"});
    }else if(this.state.domain === ""){
      this.setState({message:"all field required : domain is empty"});
    }else{
      var user = {
        ObjParamDto:{
          ARCS:0, 
          CD:null, 
          ETAT:0, 
          IDE:this.state.login, 
          LNH:null, 
          Locked:0, 
          MDP:this.state.password, 
          RecordFlag:null, 
          SIG:this.state.domain, 
          SV:0, 
          SessionIDE:""
        }, 
        Session: this.props.session
      };
  
      this.props.loginTry(user,this.props);
    }
    
  }
  onChangeLogin = (event)=>{
    this.setState({login:event.target.value});
  }
  onChangePassword = (event)=>{
    this.setState({password:event.target.value});
  }
  onChangeDomain = (event)=>{
    this.setState({domain:event.target.value});
  }


  // RENDERING ///////////////////////////////////////////////
  render() {
    var message = this.state.message; //TODO

    return (
      <div className="fullBackground">
        <div className="loginBlock loginPannel">
          <div className="extendBlocksHeader">
            <span className={"serverStatus "+this.props.serverStatus}>serveur status : {this.props.serverStatus}</span>
          </div>
          <div className="extendBlockBody">
            <div className="wrapper">
              <div className="loginLine">
                <span>Login</span>
                <input type="text" onChange={this.onChangeLogin.bind()} placeholder="Username or email"/>
              </div>
              <div className="loginLine">
                <span>Password</span>
                <input type="password" onChange={this.onChangePassword.bind()} placeholder="****"/>
              </div>
              <div className="loginLine">
                <span>Domain</span>
                <input type="text" onChange={this.onChangeDomain.bind()} placeholder="ex: 6"/>
              </div>
              <div className="error-message">
              {message}
              </div>
              
              <div className="loginLine">
                <div className="nb_button" onClick={this.toggleConnect.bind(this)}>Connect</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
    );
  }
}
const mapStateToProps = (state) => {    
  return {  
    session: state.apiReducer.session,
    serverStatus: state.apiReducer.server.Status,
  } 
}
const mapDispatchToProps = (dispatch) => {
  return {
    loginTry: (user,obj)=>dispatch(repositoryActions.loginTry(user,obj)),
  } 
} 

export default connect(mapStateToProps, mapDispatchToProps)(LoginView);